document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".unmute_icon").forEach((icon) => {
    icon.addEventListener("click", () => {
      const elm = icon.closest("default-player");
      const isMuted = icon.dataset.muted;
      if (isMuted == "true") {
        elm.querySelector("video").muted = false;
        icon.dataset.muted = "false";
      } else {
        elm.querySelector("video").muted = true;
        icon.dataset.muted = "true";
      }
    });
  });

  document.addEventListener(
    "play",
    function (event) {
      const allMedia = document.querySelectorAll("audio, video");
      allMedia.forEach((media) => {
        const isSame = media === event.target;
        const isSilent = media.muted || media.volume === 0;
        if (!isSame && !media.paused && !isSilent) {
          media.pause();
        }
      });
    },
    true
  );
});
